const discardChangesResponse = ({
  data: {
    blocks,
    chapterTitle,
    chapterTitleLocales,
    order,
    publishDate,
    success,
    updatedAt
  }
}) => {
  if (!success)
    return { editorHeaderStatus: 'error', editorIsDiscarding: false };

  return {
    editorAdders: [false, ...order.map(() => false)],
    editorBlocks: blocks,
    editorBlocksOrder: order,
    editorChapterTitle: chapterTitle,
    editorChapterTitleIsEdited: false,
    editorChapterTitleLocales: chapterTitleLocales,
    editorHeaderStatus: 'saved',
    editorHeaderUpdatedAt: updatedAt,
    editorIsDisabled: false,
    editorIsDiscarding: false,
    editorIsDraft: false,
    editorPublishDate: publishDate
  };
};

export default discardChangesResponse;
